import * as z from "zod";
import { gql } from "graphql-request";
import { Sys, SysFragment } from "../sys";
import { Image, ImageFragment } from "../image";

export const PollTargetsBaseSchema = z.object({
  pollTitle: z.string().nullable(),
  pollDescription: z.string().nullable(),
});

export const PollTargetsSchema = z.object({
  id: z.string(),
  value: z.number(),
  name: z.string(),
  imageURL: z.string(),
  maxBan: z.number().optional(),
});

export const PollTargetsArraySchema = z.array(PollTargetsSchema).nullable();

export const CarouselEventPollTargetsEntrySchema = PollTargetsBaseSchema.extend(
  {
    __typename: z.literal("CarouselEventPollTargetsEntry"),
    sys: Sys,
    entryTitle: z.string().nullable(),
    entryHideTitle: z.boolean().nullable(),
    carouselImage: Image.nullable(),
    carouselImageEn: Image.nullable(),
    pollTargets: PollTargetsArraySchema,
  },
);

export type CarouselEventPollTargetsEntry = z.infer<
  typeof CarouselEventPollTargetsEntrySchema
>;

export const CarouselEventPollTargetsEntryFragment = gql`
  fragment CarouselEventPollTargetsEntryFragment on CarouselEventPollTargetsEntry {
    __typename
    sys {
      ...SysFragment
    }

    entryTitle
    entryHideTitle
    pollTitle
    pollDescription
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    pollTargets
  }

  ${SysFragment}
  ${ImageFragment}
`;
